









































































































































































































































































































































































// @ is an alias to /src
import Vue from "vue";
import {OrderRepo, IOrderInfo} from '../libs/OrderRepository'

export default Vue.extend({
  name: "Home",
  components: {
  },
  data() {
    return {   
    };
  },
  methods: {
  
  },
  mounted: async function() {    
  },
  watch: {
   
  },
  computed: {
  }
});
